<template>
    <div class="loginPage">
        <el-row>
            <el-col :span="24">
                <div class="login_welcome_wrapper">
                    <h2>Welcome to TCL Alexa Console</h2>
                </div>
            </el-col>
        </el-row>
        <el-row>
            <el-col :span="24">
                <div class="login_welcome_wrapper">
                    <p> Login with your TCL email</p>
                </div>
            </el-col>
        </el-row>
        <el-form>
            <el-row>
                <el-col :span="6" :offset="9">
                    <div class="login_welcome_wrapper">
                        <div class="input-login-data">
                            <el-form-item label="">
                                <el-input v-model="loginForm.username" type="text" placeholder="UserName"/>
                            </el-form-item>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" :offset="9">
                    <div class="login_welcome_wrapper">
                        <div class="input-login-data">
                            <el-form-item label="">
                                <el-input v-model="loginForm.password" type="password" placeholder="Password" @keyup.enter.native="onSubmit"/>
                            </el-form-item>
                        </div>
                    </div>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="6" :offset="9">
                    <div class="login_welcome_wrapper" style="text-align: right;">
                        <el-form-item label="">
                            <el-button type="primary" @click="onSubmit">Login</el-button>
                        </el-form-item>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <el-row>
            <el-col :span="8" :offset="8">
                <div class="login_welcome_wrapper">
                     <div class="login_help">
                        <a href="/#/console/reset-password">Forgot Password?</a>
                        <a href="/#/console/signup">Create Account</a>
                     </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>


<script>

import { mapActions } from 'vuex';
import { Message } from 'element-ui';

import { USER_LOGIN } from "@/store/modules/user";
import { client } from "@/utils/client";
import { ERROR_OK } from "@/const/consts";


export default {
    data() {
        return {
            loginForm: {
                username: "",
                password: ""
            }
        }
    },
    methods: {
        // 映射 this.USER_LOGIN() 为 this.$store.dispatch('USER_LOGIN')
        ...mapActions([USER_LOGIN]),
        onSubmit() {
            console.info(this.loginForm.username, this.loginForm.password)

            this.USER_LOGIN(this.loginForm).then((data) => {
                if (data.ErrorCode == ERROR_OK) {
                    this.$router.replace({ path: '/console/' })
                } else {
                    Message.error({message: data.ErrorDescription})
                }
            }).catch(err => {
                console.error("USER_LOGIN", err)
            })
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/pages/Login.vue